import { forwardRef, type HTMLAttributes, type TableHTMLAttributes } from 'react';
import { Button } from './Button';
import { Text } from './Typography';

export type StatusTone = 'neutral' | 'success' | 'warning' | 'error' | 'info';

export function Badge({ tone = 'neutral', className = '', ...props }: HTMLAttributes<HTMLSpanElement> & { tone?: StatusTone }) {
  return <span {...props} className={`dx-badge dx-badge--${tone} ${className}`} />;
}

export const Table = forwardRef<HTMLTableElement, TableHTMLAttributes<HTMLTableElement>>(function Table({ className = '', ...props }, ref) {
  return <table {...props} ref={ref} className={`dx-table ${className}`} />;
});

export function Spinner({ label = 'Loading', className = '' }: { label?: string; className?: string }) {
  return <span className={`dx-spinner ${className}`} role="status" aria-label={label} />;
}

export function ToastNotice({ tone, title, message, onClose }: { tone: StatusTone; title: string; message?: string; onClose: () => void }) {
  return (
    <div className={`dx-toast dx-toast--${tone}`} role="alert">
      <span className="dx-toast-symbol" aria-hidden="true">{tone === 'success' ? '✓' : tone === 'error' ? '!' : tone === 'warning' ? '!' : 'i'}</span>
      <div className="dx-toast-copy">
        <Text as="div" className="dx-toast-title">{title}</Text>
        {message && <Text size="small" tone="muted">{message}</Text>}
      </div>
      <Button variant="icon" onClick={onClose} aria-label="Close notification">×</Button>
    </div>
  );
}
